import React from 'react';
import { NoSsr } from '@material-ui/core';
import styled from 'styled-components';

import Slider from './material-ui-slider';

const PLUM_SHADOW = `rgba(77, 42, 61, 0.35)`;

const PlumSlider = styled(Slider)`
  &.MuiSlider-root {
    height: 9px;
    padding: 11px 0;
  }

  .MuiSlider-mark {
    background: ${({ theme }) => theme.colors.grey[75]};
    height: 9px;
    width: 2px;
  }

  .MuiSlider-markActive {
    background: ${({ theme }) => theme.colors.white};
  }

  .MuiSlider-rail {
    background: ${({ theme }) => theme.colors.blueGrey[90]};
    border: 1px solid ${({ theme }) => theme.colors.grey[75]};
    border-radius: 7px;
    height: 9px;
    opacity: 1;
  }

  .MuiSlider-track {
    background: var(--rds-plum);
    border: none;
    border-radius: 7px;
    height: 9px;
  }

  .MuiSlider-thumb {
    background: url('/icons/slider-handle.svg') no-repeat center center;
    background-size: contain;
    border: none;
    height: 20px;
    margin-top: -6px;
    width: 20px;

    &:active,
    &:focus,
    &:hover {
      box-shadow: 0px 0px 0px 4px ${PLUM_SHADOW};
    }
  }

  &.MuiSlider-trackInverted .MuiSlider-track {
    background: ${({ theme }) => theme.colors.blueGrey[90]};
    border: 1px solid ${({ theme }) => theme.colors.grey[75]};
  }

  .MuiSlider-valueLabel {
    left: calc(-50% + 4px);
  }
`;

export default function RangeSliderPlum(props) {
  return (
    <NoSsr>
      <PlumSlider {...props} />
    </NoSsr>
  );
}
